var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ParameterizedPagedRemoteData } from "../Infra/RemoteData";
import { defaultPageSize } from "healthex-common/constants";
import { observable } from "mobx";
export class OrganizationAPIKeyManager {
    constructor(authManager, provisioningService, invalidationManager) {
        this.authManager = authManager;
        this.provisioningService = provisioningService;
        this.invalidationManager = invalidationManager;
        this.page = 0;
        this.apiKeys = new ParameterizedPagedRemoteData(this.invalidationManager, defaultPageSize, () => this.page, ({ start, end }) => this.loadApiKeys(start, end));
    }
    async loadApiKeys(start = 0, end = defaultPageSize) {
        if (!this.authManager.id || !this.authManager.orgId)
            throw new Error("User is not logged in");
        return await this.provisioningService.getAllAPIKeys(this.authManager.orgId, start, end);
    }
    async createApiKey(keyName, permissions) {
        if (this.authManager.orgId === null)
            return null;
        const creationResponse = await this.provisioningService.createAPIKey(this.authManager.orgId, keyName, permissions);
        await this.apiKeys.waitForReload();
        return creationResponse;
    }
    async updateApiKey(keyId, name, permissions) {
        if (this.authManager.orgId === null)
            return;
        await this.provisioningService.updateAPIKey(this.authManager.orgId, keyId, name, undefined, permissions);
        await this.apiKeys.waitForReload();
    }
    async deleteApiKey(keyId) {
        if (this.authManager.orgId === null)
            return;
        await this.provisioningService.deleteAPIKey(this.authManager.orgId, keyId);
        await this.apiKeys.waitForReload();
    }
    setPage(page) {
        this.page = page;
        this.apiKeys.setCurrentPage(page);
    }
}
__decorate([
    observable
], OrganizationAPIKeyManager.prototype, "page", void 0);
